/* eslint-disable graphql/template-strings */
/* eslint-disable max-len */
import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import * as apollo from 'apollo-link';
import { gql } from 'graphql-tag';
import { filter, first } from 'rxjs/operators';
import {
  MigrateSunflowerInput,
  MigrateSunflowerResponse,
} from '..';
import {
  serializeMigrateSunflowerInput,
} from '..';
import { GraphqlApiService } from '../../graphql-api/graphql-api.service';

export interface MigrateSunflowerPlantsInput {
  input?: MigrateSunflowerInput;
}
const build = (_query: DocumentNode, input: MigrateSunflowerPlantsInput, name = 'QueryResult') => {
  const bQuery = `
  mutation ${ name }(`+
    ( input.input !== undefined ? `$input: MigrateSunflowerInput = ${serializeMigrateSunflowerInput(input.input)}` : '' ) + `){
    migrateSunflowerPlants(
      ${ input.input !== undefined ? 'input: $input,' : '' }
    ){
      ...migratesunflowerresponse
    }
  }`;
  return gql`
  ${bQuery}
  ${_query}
`};

@Injectable({
  providedIn: 'root',
})
export class MigrateSunflowerPlantsMutation {
  readonly graphqlClient$ = this.graphqlApiService.client$.pipe(
    filter((available) => !!available),
  );

  readonly build = build;

  constructor(
    private readonly graphqlApiService: GraphqlApiService,
  ) { }

  /**
   * fragment migratesunflowerresponse on MigrateSunflowerResponse { ... }
   */
  async execute(_query: DocumentNode, input: MigrateSunflowerPlantsInput): Promise<apollo.FetchResult< { migrateSunflowerPlants: Partial<MigrateSunflowerResponse> }, Record<string, any>, Record<string, any>>> {
    const client = await this.graphqlClient$.pipe(first()).toPromise();
    if (!client) {
      throw Error('Missing graphql client!');
    }
    return await client?.mutate<{ migrateSunflowerPlants: Partial<MigrateSunflowerResponse> }>({ mutation: build(_query, input) });
  }
}
